export default {
  hint: 'Bestätige die Zahlung bei deiner Bank, um deine Bestellung abzuschließen.',
  cancel: 'Zahlung abbrechen',
};
